import React, { useState, useEffect } from "react";
import moment from "moment-timezone";

const Clock = () => {
    const [horaActual, setHoraActual] = useState(getHora());

    useEffect(() => {
        const interval = setInterval(() => {
            setHoraActual(getHora());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return <div>{horaActual}</div>;
};

function getHora() {
    return moment().tz("America/Lima").format("HH:mm:ss A");
}

export default Clock;
